// extracted by mini-css-extract-plugin
export var container = "styles-module--container--ILIDi";
export var desktop = "1340px";
export var dockedBottom = "styles-module--dockedBottom--f9+HG";
export var dockedTop = "styles-module--dockedTop--eMf4R";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var list = "styles-module--list--9-0NE";
export var listHeading = "styles-module--listHeading--jmIlh";
export var listHeadingHeight = "styles-module--listHeadingHeight--PWjnl";
export var listHeadingSize = "styles-module--listHeadingSize--f30lu";
export var listHeadingSpacing = "styles-module--listHeadingSpacing--fe-7W";
export var listHeadingStyle = "styles-module--listHeadingStyle--24WNy";
export var listItem = "styles-module--listItem--M8ko+";
export var listItemHeight = "styles-module--listItemHeight--cWc+x";
export var listItemSize = "styles-module--listItemSize--MkPGH";
export var listItemSpacing = "styles-module--listItemSpacing--yee+C";
export var listItemStyle = "styles-module--listItemStyle--QvqVh";
export var mobile = "400px";
export var padded = "styles-module--padded--rHktT";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";